var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIconBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1301 16.5822L23.6942 22.1496V22.154C24.1071 22.5814 24.1011 23.2608 23.6809 23.681C23.2606 24.1011 22.5811 24.107 22.1536 23.6942L16.5852 18.1268C12.3668 21.5237 6.22779 21.0282 2.60885 16.9989C-1.01009 12.9696 -0.844762 6.81402 2.98525 2.9847C6.81525 -0.844612 12.972 -1.0099 17.002 2.60838C21.0321 6.22666 21.5276 12.3645 18.1301 16.5822ZM7.15602 2.82993C4.17011 4.06639 2.22321 6.9795 2.22321 10.2108C2.22801 14.6205 5.80193 18.1943 10.2125 18.1997C13.4443 18.2001 16.3582 16.254 17.5953 13.2688C18.8324 10.2836 18.1491 6.84722 15.864 4.56219C13.5788 2.27716 10.1419 1.59346 7.15602 2.82993Z",
    fill: "#4A4A4A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIconBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/searchIconBlack.f8ff675c196f32300878f9e8f79f9c6e.svg";